import type { BduiTranslations } from '../interfaces/bdui';

export const bduiTranslations: BduiTranslations = {
  placeholder_select: 'Selecione uma opção',
  placeholder_multiselect: 'Selecione uma ou mais opções',
  placeholder_tag_list: 'Digite e pressione Enter para adicionar',
  help_tag_list:
    'Pressione Enter ou vírgula para adicionar. Clique no X para remover.',
  placeholder_kv_key: 'Chave',
  placeholder_kv_value: 'Valor',
  action_kv_add: 'Adicionar linha',
  action_kv_remove: 'Remover linha',
  action_repeater_add: 'Adicionar item',
  action_repeater_remove: 'Remover item',
  repeater_empty: 'Ainda não há itens.',
  repeater_item_title: 'Item {{index}}',

  validation_required: 'Este campo é obrigatório.',
  validation_min_length: 'Deve ter pelo menos {{length}} caracteres.',
  validation_max_length: 'Deve ter no máximo {{length}} caracteres.',
  validation_min: 'Deve ser pelo menos {{value}}.',
  validation_max: 'Deve ser no máximo {{value}}.',
  validation_invalid_option: 'Escolha uma das opções disponíveis.',

  sections_nav_label: 'Seções',
  placeholder_search: 'Buscar…',

  json_help:
    'Edite a configuração bruta. Útil para alterações em massa ou quando um assistente de IA gera o JSON para você. Salvar usa a mesma lógica de diff que o formulário.',
  json_parse_error: 'JSON inválido: {{message}}',
  json_position: 'linha {{line}}, coluna {{col}}',
  json_copy: 'Copiar',
  json_copied: 'Copiado para a área de transferência.',
  json_format: 'Formatar',
  json_validation_title: 'Validação do esquema',
  json_validation_empty: 'Nenhum problema no esquema.',
  json_copy_error: 'Não foi possível copiar para a área de transferência.',
};
